module.exports = __webpack_public_path__ + "img/horizontal_3_3_8019.eec3d5f2.png";